import { prettyCombo } from '../hotkeys/HotkeyProvider'

/**
 * A keyboard shortcut drawn as a physical key.
 *
 * Used everywhere a shortcut appears. Keeping it in one component means
 * the product's keyboard vocabulary stays consistent as screens are added.
 */
export default function Keycap(
  { combo, dark = false }: { combo: string; dark?: boolean },
) {
  return (
    <kbd className={dark ? 'keycap keycap-dark' : 'keycap'}>
      {prettyCombo(combo)}
    </kbd>
  )
}
